require('./assessment.service');
require('./assessment-history.service');
require('./assessment-question.service');
require('./assignment.service');
require('./branch.service');
require('./contract.service');
require('./custom-field-definition.service');
require('./department.service');
require('./document.service');
require('./document-requirement.service');
require('./global-notification.service');
require('./notification.service');
require('./notification-settings.service');
require('./product.service');
require('./product-category.service');
require('./report.service');
require('./user-audit.service');
require('./user.service');
require('./vendor.service');
require('./vendor-management-policy.service');
require('./vendor-update-request.service');
